import type { IconData } from '@stacksjs/iconify-core'

export const visualBlindSolid: IconData = {
  "body": "<path fill=\"currentColor\" fill-rule=\"evenodd\" d=\"M23.5 5.5C12.703 5.5 3.61 12.78.855 22.698a4.87 4.87 0 0 0 0 2.605C3.61 35.219 12.703 42.5 23.5 42.5c10.798 0 19.89-7.28 22.645-17.198a4.87 4.87 0 0 0 0-2.604C43.391 12.78 34.298 5.5 23.5 5.5m10 18.5c0 5.523-4.477 10-10 10s-10-4.477-10-10s4.477-10 10-10s10 4.477 10 10m-15.414-5.414a2 2 0 0 1 2.828 0l2.586 2.586l2.586-2.586a2 2 0 1 1 2.828 2.828L26.328 24l2.586 2.586a2 2 0 1 1-2.828 2.828L23.5 26.828l-2.586 2.586a2 2 0 1 1-2.828-2.828L20.672 24l-2.586-2.586a2 2 0 0 1 0-2.828\" clip-rule=\"evenodd\"/>",
  "width": 48,
  "height": 48,
  "viewBox": "0 0 48 48"
}

export default visualBlindSolid
